export const color = {
    primary: "#F0E4CF",
    secondary: "#130E39",
    secondaryLight: "#130E39",
    black: "#0A0A0B",
    white: "#F8F7FF",
    whiteShade: "#A8ABB4",
    bg:"#0A141B",
    purple:"#0B012E"
}